export default __webpack_public_path__ + "static/media/programme3.ddc0367e.webp";